import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export default function MyOrders() {
    const [orders, setOrders] = useState([]);
    const userId = localStorage.getItem('userId');

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const res = await api.get(`/api/orders/my-orders/${userId}`);
                setOrders(res.data);
            } catch (err) {
                console.error('Failed to fetch orders', err);
            }
        };

        if (userId) fetchOrders();
    }, [userId]);

    return (
        <div className="max-w-5xl mx-auto p-4">
            <h2 className="text-xl font-bold mb-4">My Orders</h2>

            {orders.length === 0 ? (
                <p className="text-gray-500">No orders yet.</p>
            ) : (
                <table className="w-full border">
                    <thead>
                        <tr className="bg-gray-200">
                            <th className="p-2">Order ID</th>
                            <th className="p-2">Group</th>
                            <th className="p-2">Supplier</th>
                            <th className="p-2">Portion</th>
                            <th className="p-2">Amount</th>
                            <th className="p-2">Status</th>
                            <th className="p-2">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(o => (
                            <tr key={o._id} className="text-center">
                                <td className="p-2 text-xs">{o._id}</td>
                                <td className="p-2">{o.groupId?.name}</td>
                                <td className="p-2">{o.supplierId?.name}</td>
                                <td className="p-2">{o.portion}</td>
                                <td className="p-2">${o.amountPaid}</td>
                                <td>
                                    <span className="px-2 py-1 rounded bg-gray-100 text-sm">
                                        {o.status.replaceAll('_', ' ')}
                                    </span>
                                </td>

                                <td className="p-2 text-sm">
                                    {new Date(o.createdAt).toLocaleDateString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
